import React from "react";
import { Copy, Code2, Lock } from "lucide-react";
import { toast } from "sonner";

const plain = (html) => {
    const el = document.createElement("div");
    el.innerHTML = html;
    return [...el.children].map((n) => (n.tagName === "UL"
        ? [...n.children].map((li) => `• ${li.textContent.trim()}`).join("\n") + "\n\n"
        : n.textContent.trim() + (n.tagName === "H3" ? "\n" : "\n\n"))).join("").trim();
};

/** Study Knowledgebase article (HTML generated and escaped by the backend). Copy keeps the formatting for SiteCentric's editor. */
export default function AboutStudyPanel({ about }) {
    if (!about) return <div className="text-sm text-white/50 p-6 text-center" data-testid="sb-about-empty">This build was made before the About Study article was added (v2.18).</div>;
    const copyRich = async () => {
        try {
            if (window.ClipboardItem) {
                await navigator.clipboard.write([new window.ClipboardItem({
                    "text/html": new Blob([about.html], { type: "text/html" }),
                    "text/plain": new Blob([plain(about.html)], { type: "text/plain" }),
                })]);
            } else {
                await navigator.clipboard.writeText(plain(about.html));
            }
            toast.success("Article copied — paste it into SiteCentric");
        } catch { toast.error("Copy was blocked by the browser"); }
    };
    const copyHtml = async () => { try { await navigator.clipboard.writeText(about.html); toast.success("HTML copied"); } catch { toast.error("Copy was blocked by the browser"); } };
    return (
        <div data-testid="sb-about">
            <div className="flex items-center justify-between mb-2 gap-3 flex-wrap">
                <div>
                    <div className="text-[10px] uppercase tracking-wider text-white/40">About Study</div>
                    <h3 className="font-display text-lg" data-testid="sb-about-title">{about.title}</h3>
                </div>
                <div className="flex items-center gap-2">
                    <button onClick={copyRich} data-testid="sb-about-copy" className="text-[11px] inline-flex items-center gap-1 rounded border border-[#7C3AED]/50 text-[#e2d4ff] hover:bg-[#7C3AED]/15 px-2.5 py-1"><Copy className="w-3 h-3" /> Copy article</button>
                    <button onClick={copyHtml} data-testid="sb-about-copy-html" className="text-[11px] inline-flex items-center gap-1 rounded border border-white/15 text-white/60 hover:border-white/30 px-2.5 py-1"><Code2 className="w-3 h-3" /> Copy HTML</button>
                </div>
            </div>
            <p className="text-[10px] text-white/40 mb-3 flex items-center gap-1" data-testid="sb-about-confidential">
                <Lock className="w-3 h-3 text-emerald-400" /> Never shows what the site is paid — ratios, percentages and patient stipends only
                {about.site_amounts_removed ? ` · ${about.site_amounts_removed} site amount(s) removed` : ""}
                {about.age_range ? ` · ages ${about.age_range.min}${about.age_range.max ? `–${about.age_range.max}` : "+"}${about.minors_enrolled ? " (minors → GUARDIAN)" : ""}` : ""}
            </p>
            <div className="sb-article rounded-xl border border-white/10 bg-white/[0.03] px-5 py-4 text-sm text-white/80 leading-relaxed
                            [&_h3]:font-display [&_h3]:text-base [&_h3]:text-white [&_h3]:mt-3 [&_h3:first-child]:mt-0 [&_h3]:mb-1.5
                            [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_strong]:text-white [&_p]:mt-3"
                 data-testid="sb-about-html" dangerouslySetInnerHTML={{ __html: about.html }} />
        </div>
    );
}
